module.exports = __webpack_public_path__ + "img/favorite-inactive.98944ce7.svg";